/** recoil persist key  */
export const RECOIL_PERSIST_KEY = "naval-ship-condition-recoil-persist";

export const ACCESS_TOKEN = "naval-ship-condition-access-token";
export const REFRESH_TOKEN = "naval-ship-condition-refresh-token";
